import React from 'react';
import { InvoiceDTO } from '../models/InvoiceDTO';
import InvoiceAmount from './InvoiceAmount';
import InvoiceInfo from './InvoiceInfo';
import InvoiceTable from './InvoiceTable';

interface InvoiceProps {
    invoice: InvoiceDTO,
}

const InvoiceContent: React.FunctionComponent<InvoiceProps> = (props) => {
    const { invoice } = props;

    return (
      <>
          <InvoiceInfo invoice={invoice} />

          <InvoiceTable invoice={invoice} />

          <InvoiceAmount invoice={invoice}/>
      </>
    )
}

export default InvoiceContent;